module.exports = __webpack_public_path__ + "static/design-element-e9cd7c39fed32a583cc281fcff80352e.svg";